class BackgroundDark {

    getElement() {
        if (this.element === undefined) {
            this.element = window.jQuery('#bgdark')
        }
        return this.element;
    }

    show() {
        this.getElement().show()
    }

    hide() {
        this.getElement().hide()
    }

}

const backgroundDark = new BackgroundDark();

export default {
    show() { backgroundDark.show() },
    hide() { backgroundDark.hide() },
};
